// extracted by mini-css-extract-plugin
export default {"CarouselItem":"CaseStudyCarousel_CarouselItem__6iwd2","CarouselLogo":"CaseStudyCarousel_CarouselLogo__XyN9m","CarouselImage":"CaseStudyCarousel_CarouselImage__-5yBV"};